import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { from, Observable } from 'rxjs';

import { AccountService } from './account.service';
import { UserService } from './user.service';
import {UserRole} from '../models/user/user-role';

@Injectable()
export class SupplierAuthGuard implements CanActivate, CanActivateChild {

    constructor(private accountService: AccountService, private _router: Router, private userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsSupplier(state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsSupplier(state);
    }

    private checkIsSupplier(state: RouterStateSnapshot): boolean | Observable<boolean> {
        const isLoggedIn = this.accountService.isLoggedIn();
        if (!isLoggedIn) {
            return from(this._router.navigate(['/login'], { queryParams: { redirect_to: state.url } }))
                .pipe(map(() => false));
        }

        const user = this.accountService.getCurrentUser();
        if(user.isSupplier) {
            return true;
        }

        this.userService.navigateToHomePage(user);
        return false;
    }
}
